import { buildFiltersQueryString } from '../../../../../helpers';
import type { Filter } from '../../../../../stores/filters';

export const buildEmbedParams = (filters: Filter[]): Record<string, string> => {
  const queryString = buildFiltersQueryString(filters);

  const paramsObj: Record<string, string> = {
    embed_domain: window.origin,
  };

  if (queryString) {
    const paramArray = queryString.slice(1);
    paramArray.split('&').forEach((param) => {
      const [key, value] = param.split('=');
      paramsObj[decodeURIComponent(key)] = decodeURIComponent(value);
    });
  }

  return paramsObj;
};
